module.exports = __webpack_public_path__ + "img/brainhealth-logo.92709302.svg";